import { useState } from "react";
import logo from "../assets/logo.png"; // ✅ Use imported logo

const WhatsAppChatBot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  const getCurrentTime = () => {
    const now = new Date();
    return now.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleSend = () => {
    if (message.trim()) {
      const encoded = encodeURIComponent(message);
      window.open(`https://wa.me/919024283004?text=${encoded}`, "_blank");
      setMessage("");
    }
  };

  return (
    <>
      {/* Floating WhatsApp Icon */}
      <div
        onClick={() => setIsOpen(!isOpen)}
        style={{
          position: "fixed",
          bottom: "34px",
          right: "34px",
          width: "64px",
          height: "64px",
          borderRadius: "50%",
          backgroundColor: "#25D366",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
          cursor: "pointer",
          zIndex: 999,
          animation: "pulse-ring 2s infinite",
        }}
      >
        <img
          src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
          alt="whatsapp"
          style={{ width: "36px", height: "36px" }}
        />
      </div>

      {/* Chat Window */}
      <div
        style={{
          position: "fixed",
          bottom: "100px",
          right: "20px",
          width: "340px",
          maxWidth: "90vw",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          display: isOpen ? "flex" : "none",
          flexDirection: "column",
          overflow: "hidden",
          zIndex: 1000,
        }}
      >
        {/* Header */}
        <div
          style={{
            backgroundColor: "#075e54",
            color: "white",
            padding: "12px",
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div style={{ position: "relative", width: "56px", height: "56px" }}>
            <div
              style={{
                backgroundColor: "black",
                borderRadius: "50%",
                padding: "4px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.15)",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={logo}
                alt="hotel"
                style={{ width: "100%", height: "100%", borderRadius: "50%" }}
              />
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "4px",
                right: "4px",
                width: "12px",
                height: "12px",
                backgroundColor: "#25D366",
                border: "2px solid white",
                borderRadius: "50%",
              }}
            ></div>
          </div>
          <div>
            <div style={{ fontWeight: "600" }}>The Porch Cafe & Restaurant</div>
            <div style={{ fontSize: "12px", color: "#cfd8dc" }}>
              Typically replies within 1 hour <br />
              <span style={{ color: "#e0f7fa" }}>Online</span>
            </div>
          </div>
        </div>

        {/* Chat Message */}
        <div
          style={{
            padding: "16px",
            backgroundColor: "#e5ddd5",
            flexGrow: 1,
            fontSize: "14px",
            overflowY: "auto",
          }}
        >
          <div style={{ marginBottom: "12px", textAlign: "left" }}>
            <div
              style={{
                display: "inline-block",
                backgroundColor: "white",
                padding: "10px 14px",
                borderRadius: "12px 12px 12px 0",
                maxWidth: "80%",
                color: "#303030",
                fontWeight: "500",
              }}
            >
              🌟 The Porch Cafe & Restaurant Team <br />
              Hi there! How can we help make your day amazing?
            </div>
            <div
              style={{
                fontSize: "10px",
                marginTop: "4px",
                marginLeft: "6px",
                color: "#666",
              }}
            >
              {getCurrentTime()}
              <span
                style={{
                  color: "#34B7F1",
                  fontSize: "12px",
                  marginLeft: "4px",
                }}
              >
              
              </span>
            </div>
          </div>
        </div>

        {/* Input Footer */}
        <div
          style={{
            backgroundColor: "#f0f0f0",
            padding: "10px",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <input
            type="text"
            value={message}
            placeholder="Type your message..."
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleSend()}
            style={{
              flex: 1,
              padding: "8px 12px",
              borderRadius: "20px",
              border: "1px solid #ccc",
              outline: "none",
              fontSize: "14px",
            }}
          />
          <button
            onClick={handleSend}
            style={{
              backgroundColor: "#25D366",
              color: "white",
              padding: "8px 16px",
              borderRadius: "20px",
              border: "none",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Send
          </button>
        </div>
      </div>

      {/* Black Close Button */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          style={{
            position: "fixed",
            bottom: "calc(100px + 300px + 10px)",
            right: "20px",
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            backgroundColor: "white",
            color: "black",
            fontSize: "20px",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
            zIndex: 100,
            boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
          }}
          title="Close chat"
        >
          ×
        </div>
      )}

      {/* Ring Animation */}
      <style>
        {`
          @keyframes pulse-ring {
            0% {
              box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.4);
            }
            70% {
              box-shadow: 0 0 0 12px rgba(37, 211, 102, 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(37, 211, 102, 0);
            }
          }
        `}
      </style>
    </>
  );
};

export default WhatsAppChatBot;
